import { SysCodeDto } from 'src/dtos/code/sysCodeDto';

/**
 * sys_code major_cd=PROGRAM, minor_cd=ITEM_POPUP_SEARCH
 * - ref01: 필터 사용 여부 (WMS1130/1140 등)
 * - ref02: Lot라벨자동출력 기본값 (Y/N)
 */
export const LABEEL_PRINT = 'LABEEL_PRINT';

export const getDefaultLabelPrintAuto = (programList: SysCodeDto[]): 'Y' | 'N' => {
	const ref02 = programList.find(c => c.minorCd === LABEEL_PRINT)?.ref01;
	return ref02?.trim().toUpperCase() === 'Y' ? 'Y' : 'N';
};
